import React from 'react';

export const CreditLineIcon = () => (
  <svg
    width="35px"
    height="24px"
    viewBox="0 0 35 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>linea-credito-icon</title>
    <desc>Created with Sketch.</desc>
    <g id="linea-credito-icon" stroke="none" fill="none">
      <g id="Bank-card-36px" transform="translate(-1.000000, 0.000000)">
        <g id="Group-411">
          <path
            d="M6,14.7258065 L30.154074,14.7258065"
            id="Stroke-409"
            stroke="#7462E0"
          />
          <path
            d="M6,18.3548387 L17.544148,18.3548387"
            id="Stroke-410"
            stroke="#7462E0"
          />
          <path
            d={[
              'M2.40625,1.68548387 C2.02655423,1.68548387 1.71875,1.99328811 1.71875,2.37298387 L1.71875,21.9979839',
              'C1.71875,22.3776796 2.02655423,22.6854839 2.40625,22.6854839 L34.03125,22.6854839 C34.4109458',
              '22.6854839',
              ' 34.71875,22.3776796 34.71875,21.9979839 L34.71875,2.37298387 C34.71875,1.99328811 ',
              '34.4109458,1.68548387',
              ' 34.03125,1.68548387 L2.40625,1.68548387 Z'
            ].join(' ')}
            id="Rectangle-6"
            stroke="#D1402C"
          />
          <polygon
            id="Stroke-407"
            stroke="#D1402C"
            points="6 11.0967742 11.03125 11.0967742 11.03125 6.01612903 6 6.01612903"
          />
        </g>
      </g>
    </g>
  </svg>
);
